export default __webpack_public_path__ + "static/media/celebrate.cfa234ae9d0489a2f152991b07101868.svg";